export default __webpack_public_path__ + "static/media/Vector (2).85f298c6.svg";